import type { FunctionComponent } from 'react';

import './style.scss';

const RequiredField: FunctionComponent = () => (
  <div styleName="label">
    Required field
  </div>
);

export default RequiredField;
